import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentPopupList = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.list,
)
